<template>
    <search-autocomplete
        v-model="userId"
        label="number_name"
        :value-key="(item) => (item.user.id)"
        state-name="pages/partners"
        v-bind="$attrs"
        @focus="$emit('focus', $event)"
        :search-method="partnerSearch">
        <template v-slot="props">
            {{ props.item.number_name }}
        </template>
    </search-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';
import SearchAutocomplete from "../SearchAutocomplete";

export default {
    name: "SearchPartner",
    components: {SearchAutocomplete},
    props: {
        value: {
            requested: true,
            default: () => ''
        },
    },
    data: () => ({
        userId: '',
    }),
    watch: {
        value(val) {
            this.$set(this, 'userId', val);
        },
        userId(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        ...mapActions('pages', [
            'partnerSearch'
        ])
    },
    mounted() {
        this.$set(this, 'userId', this.value);
    }
}
</script>